import { render, staticRenderFns } from "./RemarkDeal.vue?vue&type=template&id=7702a5ab&scoped=true&"
import script from "./RemarkDeal.vue?vue&type=script&lang=js&"
export * from "./RemarkDeal.vue?vue&type=script&lang=js&"
import style0 from "./RemarkDeal.vue?vue&type=style&index=0&id=7702a5ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7702a5ab",
  null
  
)

export default component.exports